<app-upsell-card [htmlTitle]="htmlTitle" [question]="question" [options]="options" [hints]="hints">
  <ng-content>
    <p class="mb-4">
      Peptides support recovery, circulation, and cellular repair — but
      <strong>testosterone is what ultimately determines strength, energy, libido, and consistency.</strong>
    </p>

    <p class="mb-4">That's why many men pair peptides with <strong>Testosterone Replacement Therapy (TRT).</strong></p>

    <p class="mb-4">TRT helps restore testosterone to optimized levels, leading to:</p>

    <ul class="mb-4">
      <li>Stronger libido and firmer erections</li>
      <li>More energy and better workouts</li>
      <li>Improved body composition</li>
      <li>More consistent, noticeable results from peptides</li>
    </ul>

    <p class="mb-4">
      When combined, <strong>peptides + TRT work synergistically</strong> to enhance performance, recovery, and sexual
      health.
    </p>

    <p class="mb-4"><strong>Choose the TRT Option That Matches Your Goals</strong></p>

    <ul class="mb-4">
      <li>
        <strong>Injectable TRT</strong> – Direct testosterone optimization for maximum performance and consistency
      </li>
      <li><strong>TRT + Enclomiphene</strong> – Optimized testosterone while supporting natural hormone signaling</li>
      <li><strong>TRT + hCG</strong> – Advanced hormonal support to enhance peptide results and overall vitality</li>
    </ul>

    <p class="mb-4">
      Adding TRT is one of the most effective ways to
      <strong>unlock the full potential of your peptide protocol.</strong>
    </p>
  </ng-content>
</app-upsell-card>
